import { gql } from "@apollo/client"

export const GET_COMPANIES = gql`
query GetCompanies($query: String, $first: Int, $after: String) {
  companies(query: $query, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      cursor
      node {
        id
        name
        createdAt
        type
        paidUsers
        activeUsers
        companySubscriptions {
          startDate
          endDate
          status
          id
          subscription {
            name
            description
            id
          }
        }
        companyConsentPolicy{
          needParentalConsent
          autoParentalConsent
          timeoutWindow
        }
        companyInterventionPolicy{
          abuseAtHome
          safeAtHome
          suicide
        }
        locations {
          id
          name
          streetLineOne
          streetLineTwo
          city
          country
          state
          postalCode
          customFields {
            id
            name
            type
            required
            description
          }
        }
      }
    }
  }
}
`;